import { render } from "./ClanQuadro.vue?vue&type=template&id=2d407b20&scoped=true"
import script from "./ClanQuadro.vue?vue&type=script&lang=js"
export * from "./ClanQuadro.vue?vue&type=script&lang=js"

import "./ClanQuadro.vue?vue&type=style&index=0&id=2d407b20&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2d407b20"]])

export default __exports__